<div class="prism-select flex flex-col text-base">
  @if (effectiveLabel) {
    <label
      [id]="labelId"
      [class]="effectiveLabelClass">
      {{ effectiveLabel }}
      @if (required) {
        <span class="text-red" aria-hidden="true">*</span>
        <span class="sr-only"> required</span>
      }
    </label>
  }

  <div class="prism-select-wrapper relative">
    <div
      #triggerEl
      class="prism-select-trigger w-full px-2 py-1 border border-dark-purple rounded-lg bg-white text-base flex flex-wrap items-center gap-1"
      [class.is-disabled]="readOnly"
      [class.is-invalid]="control?.invalid && (control?.dirty || control?.touched)"
      (mousedown)="onTriggerClick($event)">

      @if (multiSelect) {
        @for (chip of selectedChips; track chip.id) {
          <span class="prism-select-chip">
            <span class="prism-select-chip-label">{{ chip.name }}</span>
            <button
              type="button"
              class="prism-select-chip-remove"
              [attr.aria-label]="'Remove ' + chip.name"
              [disabled]="readOnly"
              (mousedown)="$event.stopPropagation()"
              (click)="removeChip(chip, $event)">
              &times;
            </button>
          </span>
        }
      }

      <input
        #searchInput
        type="text"
        class="prism-select-search-input"
        role="combobox"
        autocomplete="off"
        aria-autocomplete="list"
        [id]="inputId"
        [attr.aria-labelledby]="effectiveLabel ? labelId : null"
        [attr.aria-expanded]="isOpen"
        aria-haspopup="listbox"
        [attr.aria-controls]="listboxId"
        [attr.aria-activedescendant]="activeOptionId"
        [attr.aria-required]="required ? 'true' : null"
        [attr.aria-invalid]="control?.invalid && (control?.dirty || control?.touched) ? 'true' : null"
        [value]="inputDisplayValue"
        [disabled]="readOnly"
        (input)="onInputChange($any($event.target).value)"
        (keydown)="onKeyDown($event)" />

      @if (!inputDisplayValue && (!multiSelect || !selectedChips.length)) {
        <span class="prism-select-placeholder" aria-hidden="true">{{ placeHolder }}</span>
      }

      <span class="prism-select-arrow" aria-hidden="true" [class.is-open]="isOpen"></span>
    </div>

    <div
      #listboxEl
      class="prism-select-dropdown"
      [class.is-hidden]="!isOpen"
      tabindex="0"
      role="region"
      aria-label="Dropdown options"
      [style.top.px]="dropdownTop"
      [style.left.px]="dropdownLeft"
      [style.width.px]="dropdownWidth">
      <ul
        class="prism-select-listbox"
        role="listbox"
        [id]="listboxId"
        [attr.aria-label]="accessibleName"
        [attr.aria-multiselectable]="multiSelect ? 'true' : null">

        @if (allowDeselect) {
          <li
            class="prism-select-option is-deselect"
            role="option"
            [attr.aria-selected]="isSelected(null)"
            (mousedown)="$event.preventDefault()"
            (click)="selectOption(null)">
            {{ placeHolder }}
          </li>
        }

        @for (item of flatItems; track $index) {
          @if (item.type === 'group') {
            <li class="prism-select-group-label" role="presentation">
              {{ item.label }}
            </li>
          } @else {
            <li
              [id]="optionId(item.option)"
              class="prism-select-option"
              role="option"
              [class.is-active]="activeIndex === item.optionIndex"
              [class.is-selected]="isSelected(item.option)"
              [class.is-disabled]="isDisabledOption(item.option)"
              [attr.aria-selected]="isSelected(item.option) || (!multiSelect && activeIndex === item.optionIndex)"
              [attr.aria-disabled]="isDisabledOption(item.option) ? 'true' : null"
              (mousedown)="$event.preventDefault()"
              (click)="selectOption(item.option)"
              (mouseenter)="activeIndex = item.optionIndex">
              @if (multiSelect) {
                <span class="prism-select-checkmark" aria-hidden="true">
                  {{ isSelected(item.option) ? '✓' : '' }}
                </span>
              }
              <span class="prism-select-option-text">{{ item.option.name }}</span>
            </li>
          }
        }

        @if (flatItems.length === 0) {
          <li class="prism-select-empty" role="presentation">No results</li>
        }
      </ul>
    </div>
  </div>

  @if (control?.invalid && (control?.dirty || control?.touched)) {
    <p class="text-sm text-red pt-1">
      {{ label || 'Selection' }} is invalid.
    </p>
  }
</div>
